import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { TimeBucketUnits } from '@iotv/datamodel-core';
import { SortOrder } from '@iotv/iotv-v3-types';
import { Alert, Stack } from '@mui/material';
import { useContext, useEffect, useReducer } from 'react';
import { NodeEdgeMapperContext } from '../../../ContextProviders/NodeEdgeMapperComponentContext';
import { NetWorkDAO } from '../../../data/NetworkDAO';
import { PeriodRecent, useModularTimePeriodSelector } from '../../../hooks/useModularTimePeriodSelector';
import { useTimeBucketSelector } from '../../../hooks/useTimeBucketSelector';
import { GoogleChartWrapper } from '../../../v2/components/charts/GoogleChartWrapper';
const debug = process.env.REACT_APP_DEBUG && false;
export const Status = ({ viewObject }) => {
    const { matchedPrimary } = viewObject;
    const { state: {}, } = useContext(NodeEdgeMapperContext);
    const [state, dispatch] = useReducer((state, action) => {
        return { ...state, ...action };
    }, { metrics: null, inFlight: false });
    const { fromDateValue, toDateValue, components: { TimePeriodSelector }, } = useModularTimePeriodSelector({
        rangeUnit: 'days',
        rangeLength: 10,
        allowedRangeUnits: ['days'],
        initialPeriodRecent: PeriodRecent.RECENT,
        requireConfirmation: true,
    });
    const { state: [timeBucketDef], components: { unit, width }, } = useTimeBucketSelector({ unit: TimeBucketUnits.HOUR, width: 1 });
    const getMetrics = async (applicationServerSk) => {
        dispatch({ inFlight: true });
        const { unit, width } = timeBucketDef;
        const res = await NetWorkDAO.geLNSMetricsFromTimestream({
            duration: width,
            units: unit,
            fromDateValue,
            toDateValue,
            sortOrder: SortOrder.DESCENDING,
            applicationServerSks: [applicationServerSk],
        });
        console.log('LNS Metrics: ', res);
        const { err, data } = res;
        if (err) {
            console.error('Error fetching LNS metrics: ', err);
            return;
        }
        else if (data) {
            dispatch({ metrics: data, inFlight: false });
        }
    };
    useEffect(() => {
        if (matchedPrimary?.sk) {
            getMetrics(matchedPrimary.sk);
        }
        return () => {
            dispatch({ metrics: null, inFlight: false });
        };
    }, [matchedPrimary?.sk, fromDateValue, toDateValue, timeBucketDef]);
    const chartClass = google.visualization.ColumnChart;
    const options = {
        title: 'LNS Metrics',
        legend: { position: 'bottom' },
        hAxis: {
            title: 'Time',
            format: 'MM/dd/yyyy HH:mm',
        },
        vAxis: {
            title: 'Value',
        },
        series: {
            0: { type: 'bars', color: '#1f77b4' }, // currentRate
            1: { type: 'bars', color: '#ff7f0e' }, // uplinks
            2: { type: 'bars', color: '#2ca02c' }, // downlinks
            3: { type: 'bars', color: '#d62728' }, // droppedMsgs
            4: { type: 'line', color: '#9467bd' }, // messagesPerPeriodMax
        },
    };
    const data = new google.visualization.DataTable();
    data.addColumn('datetime', 'Time');
    data.addColumn('number', 'Current Rate');
    data.addColumn('number', 'Uplinks');
    data.addColumn('number', 'Downlinks');
    data.addColumn('number', 'Dropped Messages');
    data.addColumn('number', 'Max Messages Per Period');
    if (state.metrics) {
        const rows = state.metrics.map((metric) => {
            const row = [];
            const { bucketStart, bucketEnd, currentRate, uplinks, downlinks, droppedMsgs, messagesPerPeriodMax } = metric;
            row.push(new Date(bucketStart));
            row.push(currentRate);
            row.push(uplinks);
            row.push(downlinks);
            row.push(droppedMsgs);
            row.push(messagesPerPeriodMax);
            return row;
        });
        data.addRows(rows);
    }
    const fragmentProps = {
        style: { height: '30vh', maxHeight: 300, width: '100%' },
    };
    return (_jsxs(Stack, { direction: 'column', spacing: 2, padding: 2, height: '100%', children: [_jsxs(Stack, { direction: "row", gap: 2, flexWrap: "wrap", alignItems: "center", children: [TimePeriodSelector, width, unit] }), state.metrics && (_jsx(Stack, { direction: "row", flexWrap: "wrap", gap: 2, children: state.inFlight ? (_jsx(Alert, { severity: 'info', children: "Loading..." })) : data.getNumberOfRows() === 0 ? (_jsx(Alert, { severity: 'info', children: "No data for selected time period" })) : (_jsx(GoogleChartWrapper, { chartClass, options, fragmentProps, data })) }))] }));
};
